<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'usersCrud'"
          crudName="Veículos"
          newText="Novo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "veiculoTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: [
        "veiculo_id",
        "nome_veiculo",
        "placa_veiculo",
        "marca_veiculo",
        "modelo_veiculo",
        "actions",
      ],
      tableData: [
        "veiculo_id",
        "nome_veiculo",
        "placa_veiculo",
        "marca_veiculo",
        "modelo_veiculo",
        "cor_veiculo",
        "cnes",
        "observacao",
        "data_registro",
        "tipo_veiculo_id",
        "status",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "veiculo_id",
          "nome_veiculo",
          "placa_veiculo",
          "marca_veiculo",
          "modelo_veiculo",
          "status",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          veiculo_id: "ID",
          nome_veiculo: "Nome do Veículo",
          placa_veiculo: "Placa do Veículo",
          marca_veiculo: "Marca do Veículo",
          modelo_veiculo: "Modelo do Veículo",
          cor_veiculo: "Cor do Veículo",
          cnes: "CNES",
          observacao: "Observação",
          data_registro: "Data do Registro",
          tipo_veiculo_id: "Tipo do Veículo",
          status: "Status",
          actions: "Ações",
        },
        sortable: [
          "veiculo_id",
          "nome_veiculo",
          "placa_veiculo",
          "marca_veiculo",
          "modelo_veiculo",
          "status",
        ],
        sortIcon: {
          base: "fas",
          up: "fa-chevron-up",
          down: "fa-chevron-down",
          is: "fa-sort",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ],
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          console.log(this.$parent.$parent);

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company"];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "veiculo",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let fileImport = document.getElementById("fileImport");

      fd.append("fileImport", fileImport.files[0] ? fileImport.files[0] : "");

      return fd;
    },
    query: function (query) {
      let columns = {
        veiculo_id: "veiculo_id",
        nome_veiculo: "nome_veiculo",
        placa_veiculo: "placa_veiculo",
        marca_veiculo: "marca_veiculo",
        modelo_veiculo: "modelo_veiculo",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>